import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, enableVariablesMapping } from 'store/data/variablesMapping';

type HandlerInput = Parameters<typeof enableVariablesMapping>;

export function useEnableVariableMapping(activityPayload: {
	setName?: string;
}): Operation<(...input: HandlerInput) => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.ENABLE_VARIABLES_MAPPING,
		activityPayload
	);

	async function handler(...input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		await dispatch(enableVariablesMapping(...input));
	}

	return [{ loading, error }, handler];
}
